import { render, staticRenderFns } from "./TripleComponentCreator.vue?vue&type=template&id=59e6dae8&scoped=true"
import script from "./TripleComponentCreator.vue?vue&type=script&lang=js"
export * from "./TripleComponentCreator.vue?vue&type=script&lang=js"
import style0 from "./TripleComponentCreator.vue?vue&type=style&index=0&id=59e6dae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e6dae8",
  null
  
)

export default component.exports